import { useEffect, useState } from "react";
import "./timeline.css";
import Sau from "./Project.module.css";
import {
  faEllipsisVertical,
  faEnvelope,
  faPhone,
  faPlus,
  faXmark,
  faCheck,
  faChevronDown,
  faChevronUp,
  faEdit,
  faClone,
  faMailForward,
  faCalendar,
  faUser,
  faListCheck,
  faCalendarDays,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import projectIcon from "../../Utils/assets/img/icons/projectIcon.png";
import { Calendar, CheckSquare, FileCheck, StickyNote } from "lucide-react";
import nodata from "../../Utils/assets/img/leads_no_data_found.png"
import {
  Col,
  Row,
  Tab,
  Nav,
  Modal,
  Dropdown,
  Button,
  Form,
  Offcanvas,
  Card,
  Badge,
} from "react-bootstrap";
import { FaStickyNote, FaWhatsapp } from "react-icons/fa";
import imgs from "../../Utils/assets/img/faces/5.jpg";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

import { TasksOffcanvas } from "./TasksOffcanvas";
import DocumentsList from "../detailPage/DocumentsList";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { Meetings } from "../detailPage/leads/Meetings";
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  formatDate,
  formatDateInAlphabeticalMonth,
  formatTime,
  maskContactNumber,
} from "../../Utils/helpers/commonhelper";
import {
  BsFillDropletFill,
  BsGearFill,
  BsPersonFill,
  BsLightbulbFill,
} from "react-icons/bs";
import DeleteModal from "../DeleteModal";
import ReactQuill from "react-quill";
import ProjectDetailSkeleton from "./ProjectDetailSkeleton";
import { defaultImage } from "../../Utils/constants/constant";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import ExpandableNote from "../detailPage/Contacts/ContactDetails";


// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const events = [
  {
    time: "08:00",
    title: "Morning watering initiated.",
    icon: <BsFillDropletFill />,
    iconType: "blue",
  },
  {
    time: "07:40",
    title: "Ventilation system power set to 80%",
    icon: <BsGearFill />,
    iconType: "gray",
  },
  {
    time: "07:23",
    title: "Authorized personnel entered facility.",
    icon: <BsPersonFill />,
    iconType: "gray",
  },
  {
    time: "06:12",
    title: "Main light source set to 1200 LUX",
    icon: <BsLightbulbFill />,
    iconType: "orange",
  },
];

export const ProjectDetails = ({
  show,
  onClose,
  projectIdForDetailPage,
  refetch,
  moduleName,
}) => {
  // State management
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [customer, setCustomer] = useLocalStorageState("customer");
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  const [taskShow, setTaskShow] = useState(false);
  const [documentShow, setDocumentShow] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [addIndivisbleTask, setAddIndivisualTask] = useState(false);
  const [editTastData, setEditTaskData] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [notesError, setNotesError] = useState(null);
  const [notes, setNotes] = useState([]);
  const [notesContent, setNotesContent] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [isNotesLoading, setIsNotesLoading] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(true);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [stageData, setStageData] = useState([]);
  const [expandedStages, setExpandedStages] = useState({});
  const [fetchTaskToken, setFetchTaskToken] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [completeTaskClicked, setTaskCompleteClick] = useState(false);
  const [cancleTaskClicked, setTaskCancleClick] = useState(false);
  const [inCompleteTaskClicked, setTaskInCompleteClick] = useState(false);
  const [toChangeTaskStatus, setToChangeTaskStatus] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [deleteDocument, setDeleteDocument] = useState(false)



  // permission setup for purchase order
  const permission = customer.customer_details?.permission
  const isProject = Boolean(permission?.find(c => c.module_name === "project"))
  const projectPermission = permission?.filter(c => c.module_name === "project")
  const user_type = Number(customer.customer_details?.user_type)

  const taskGrant = {
    isView: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "task")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "task")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "task")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "task")?.delete)) : true,
  }
  const meetingGrant = {
    isView: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "meeting")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "meeting")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "meeting")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "meeting")?.delete)) : true,
  }
  const noteGrant = {
    isView: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "notes")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "notes")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "notes")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "notes")?.delete)) : true,
  }
  const docGrant = {
    isView: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "document")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "document")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "document")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isProject && projectPermission?.find(c => c.feature_name === "document")?.delete)) : true,
  }
  const handleCloseModal = () => {
    setShowConfirm(false);
    setRejectReason("");
    setLoading(false);
    setTaskCompleteClick(false);
    setTaskCancleClick(false);
    setTaskInCompleteClick(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      let taskStatus;

      if (completeTaskClicked) {
        taskStatus = "complete";
      } else if (inCompleteTaskClicked) {
        taskStatus = "progress";
      } else if (cancleTaskClicked) {
        taskStatus = "close";
      }

      const payload = {
        stage_id: toChangeTaskStatus,
        task_id: taskId,
        task_status: taskStatus,
        reason: rejectReason,
      };

      const res = await PutRequest(
        `project/changeTaskStatus`,
        payload,
        { headers },
        extras
      );

      if (!res || res.status === "fail") {
        return toast.error(res.message || "something went wrong");
      }
      if (res.status === "success") {
        toast.success(res.message);
        setToChangeTaskStatus();
        setRejectReason("");
        fetchStages();
        await fetchDetailsProjects();

        setShowConfirm(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowConfirm(false);
      setLoading(false);
    }
  };

  const handleCheckBoxClick = async (task) => {
    try {
      if (!task) {
        return;
      }

      let taskStatus;
      if (task.task_status === "complete") {
        taskStatus = "progress";
      } else {
        taskStatus = "complete";
      }

      const payload = {
        stage_id: task?.project_stage_id,
        task_id: task?.id,
        task_status: taskStatus,
        reason: "",
      };
      const res = await PutRequest(
        `project/changeTaskStatus`,
        payload,
        { headers },
        extras
      );

      if (res.status === "fail") {
        return toast.error(res.message);
      }

      await fetchDetailsProjects();
      fetchStages();
    } catch (error) { }
  };

  const fetchDetailsProjects = async () => {
    if (!projectIdForDetailPage) {
      return;
    }
    try {
      setIsLoading(true);
      const res = await GetRequest(
        `/project/fetchDetailsProjects/${customerId}/${projectIdForDetailPage}`,
        { headers },
        extras
      );
      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message);
      }

      setProjectData(res.data[0]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const apiUrl = `project/fetchDocuments/${customerId}/${projectData?.id}`

  const {
    data: documentData,
    error,
    refetch: fetchDocument,
    isError,
    // isLoading,
  } = useGetRequest(apiUrl, "getDocument", headers, extras);

  // Update documents
  useEffect(() => {
    if (documentData?.status === "success") {
      setDocuments(documentData?.data);
    } else if (isError) {
      console.error("Error fetching documents:", error);
    }
  }, [documentData, isError, error]);

  useEffect(() => {
    if (projectIdForDetailPage) {
      fetchDetailsProjects();
    }
  }, [customerId, projectIdForDetailPage, fetchTaskToken]);

  const fetchStages = async () => {
    setStageData([]);
    try {
      const res = await GetRequest(
        `project/getProgressOfStagesTask/${customerId}/${projectData?.id}`,
        { headers },
        extras
      );

      if (res.status !== "success") return;

      setStageData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchStages();
  }, [projectData?.id, fetchTaskToken, customer]);

  const phoneData = JSON.parse(projectData?.user_phone || "[]");

  const firstPhone = phoneData[0]?.phone;
  const phoneCountryCode = phoneData[0]?.country_code;

  const handleIndividualtask = (stage) => {
    setAddIndivisualTask(true);
    setEditTaskData(stage);
    setTaskShow(true);
  };

  const handleAddTask = () => {
    setProjectId(projectData?.id);
    setTaskShow(true);
  };

  const toggleStageExpansion = (stageId) => {
    setExpandedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  const handleCompleteTask = (task) => {
    setTaskCompleteClick(true);
    handleConfirmationTask(task);
  };
  const handleInCompleteTask = (task) => {
    setTaskInCompleteClick(true);
    handleConfirmationTask(task);
  };
  const handleCancleTask = (task) => {
    setTaskCancleClick(true);
    handleConfirmationTask(task);
  };
  const handleConfirmationTask = (task) => {
    setShowConfirm(true);
    setToChangeTaskStatus(task?.project_stage_id);
    setTaskId(task?.id);
  };



  const handleConfirmedDelete = async () => {
    setLoading(true)

    try {

      const item = documents.find((doc) => doc.id === documentToDelete);

      if (!item) return toast.error("no record find to delete");

      const res = await DeleteRequest(
        `/project/DeleteDocuments/${projectData?.id}/${documentToDelete}`,
        { headers },
        extras
      );


      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message || "failed to delete document");
      }

      if (res.status === "success") {
        toast.success(res.message || "document deleted successfully");
        setDocuments((prevDocs) =>
          prevDocs.filter((doc) => doc.id !== documentToDelete)
        );
        await fetchDocument();
        setDeleteDocument(false)
      }
    } catch (error) {
      console.error("Delete error", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false);
      setDocumentToDelete(null);
    }
  };


  const calculateStageCompletion = (stage) => {
    if (!stage.tasks || stage.tasks.length === 0) return 0;
    const completedTasks = stage.tasks.filter(
      (task) => task.status === "completed" || task.is_completed
    ).length;
    return Math.round((completedTasks / stage.tasks.length) * 100);
  };

  useEffect(() => {
    if (projectData) {
      fetchNotes();
    }
  }, [customer, projectData]);

  const fetchNotes = async () => {
    setIsNotesLoading(true);
    setNotesError(null);

    try {
      const response = await GetRequest(
        `project/fetchNotes/${projectData?.id}/${customerId}`,
        { headers },
        extras
      );

      if (response.data) {
        setNotes(response.data);
      } else {
        setNotesError("Failed to load notes");
      }
    } catch (error) {
      setNotesError(error.message || "Error loading notes");
    } finally {
      setIsNotesLoading(false);
    }
  };

  // Handle create/update note
  const handleSaveNote = async () => {
    if (!notesContent.trim()) {
      setNotesError("Please enter some notes before submitting");
      return;
    }

    setIsNotesLoading(true);
    setNotesError(null);
    try {
      let response;
      const noteData = {
        customer_id: customerId,
        project: projectData?.id,
        notes: notesContent,
        user_login_id: customer?.customer_details?.id,
      };

      if (editingNoteId) {
        // Update existing note
        response = await PutRequest(
          "project/updateNote",
          { ...noteData, note_id: editingNoteId },
          { headers },
          extras
        );
      } else {
        // Create new note
        response = await PostRequest(
          "project/createNote",
          noteData,
          false,
          { headers },
          extras
        );
      }

      if (response.data) {
        toast.success(
          `Note ${editingNoteId ? "updated" : "created"} successfully`
        );
        setNotesContent("");
        setEditingNoteId(null);
        fetchNotes(); // Refresh notes list
      } else {
        setNotesError(
          response.message ||
          `Failed to ${editingNoteId ? "update" : "create"} note`
        );
      }
    } catch (error) {
      setNotesError(error.message || "Error saving note");
    } finally {
      setIsNotesLoading(false);
    }
  };

  const handleEditNote = async (noteId) => {
    setIsNotesLoading(true);
    setNotesError(null);

    try {
      const response = await GetRequest(
        `project/getNotesById/${noteId}/${projectData?.id}`,
        { headers },
        extras
      );

      if (response.data && response.data.length > 0) {
        const note = response.data[0];
        setNotesContent(note.notes);
        setEditingNoteId(noteId);
        setIsNotesOpen(false);
      } else {
        setNotesError("Failed to load note for editing");
      }
    } catch (error) {
      setNotesError(error.message || "Error loading note");
    } finally {
      setIsNotesLoading(false);
    }
  };

  function forceInline(html) {
    const blockTags = ["div", "p", "h1", "h2", "h3", "h4", "h5", "h6"];

    let processed = html;
    blockTags.forEach((tag) => {
      const regex = new RegExp(`<${tag}`, "gi");
      processed = processed.replace(regex, `<${tag} style="display:inline"`);
    });

    return processed;
  }

  const handleOnCloseClick = async () => {
    setProjectData([]);
    setProjectId(null);
    setStageData([]);
    onClose();
    if (moduleName === "ProjectDashboard") {
      await refetch();
    }
  };

  // Handle delete note
  const handleDeleteNote = async (noteId) => {
    setIsNotesLoading(true);
    setNotesError(null);
    setLoading(true)
    try {
      const response = await DeleteRequest(
        `project/deleteNotes/${projectData?.id}/${noteId.id}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      if (response.status == "success") {
        toast.success("Note deleted successfully");
        fetchNotes(); // Refresh notes list
        setShowDeleteModal(false);
      } else {
        setNotesError(response.message || "Failed to delete note");
      }
    } catch (error) {
      setNotesError(error.message || "Error deleting note");
    } finally {
      setLoading(false)
      setIsNotesLoading(false);
    }
  };

  const onDelete = (id) => {
    setDocumentToDelete(id);
    setShowDeleteModal(true);
    setDeleteDocument(true);
  };

  const lightColors = [
    "#FDE2E4",
    "#FFF1E6",
    "#E2ECE9",
    "#FDECF2",
    "#E8F3FF",
    "#F4F9E9",
    "#FFEEDD",
    "#E7E6FF",
  ];
  const getRestrictedLightColor = () => {
    return lightColors[Math.floor(Math.random() * lightColors.length)];
  };

  //   const getRandomLightColor = () => {
  //   const r = 220 + Math.floor(Math.random() * 35); // 200–255
  //   const g = 220 + Math.floor(Math.random() * 35);
  //   const b = 220 + Math.floor(Math.random() * 35);
  //   return `rgb(${r}, ${g}, ${b})`;
  // };

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeleteNote(noteToDelete)}
        note={noteToDelete}
        isLoading={loading}
        message="Are you want delete notes?"
      />
      {deleteDocument &&
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmedDelete}
          isLoading={loading}
          message={"Are you sure you want to permanently delete this document?"}
        />}

      <>
        <Offcanvas
          className="w-100 d-flex"
          show={show}
          backdrop="static"
          onHide={handleOnCloseClick}
          placement="end"
          style={{ padding: "10px" }}
          id="contactDetailsOffcanvas"
        >
          {isLoading ? (
            <ProjectDetailSkeleton />
          ) : (
            <>
              <Offcanvas.Header
                style={{
                  background: "#f3f3f3",
                  borderBottom: "none",
                  paddingBottom: "0",
                }}
              >
                <div
                  className="w-100 d-flex align-items-center justify-content-between fs-13"
                  style={{ padding: "2px 7px 13px", color: "#0081d7" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant="light"
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        pointerEvents: "none",
                        cursor: "no-drop",
                        height: "30px",
                        fontWeight: 300,
                        fontSize: "13px",
                        borderRadius: 2,
                        border: "1px solid lightblue",
                        padding: "0 10px",
                      }}
                    >
                      Project Details
                    </Button>
                  </div>
                  <div>
                    <div className="d-flex align-items-center gap-1">
                      <Button
                        variant="default"
                        className="btnss"
                        style={styles.listButtonsStyles}
                        onClick={() => {
                          handleOnCloseClick();
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} className="ms-0" />
                      </Button>
                    </div>
                  </div>
                </div>
              </Offcanvas.Header>
              <Offcanvas.Body
                className="pt-0"
                style={{ background: "#f3f3f3" }}
              >
                <Row className="ms-0">
                  <Col
                    md={7}
                    className="ps-0 contactInformation"
                    style={{ height: "96%", paddingRight: 0 }}
                  >
                    <Card
                      className="me-2 my-card"
                      style={{
                        paddingTop: "12px",
                        borderRadius: "5px",
                        border: "1px solid #e0e4f8",
                        marginBottom: "10px",
                      }}
                    >
                      <style>
                        {`
                          .my-card {
                            padding-top: 12px !important;
                            border-radius: 5px;
                            border: 1px solid #e0e4f8;
                            margin-bottom: 2px !important;
                          }
                        `}
                      </style>
                      {/* <Card.Body className="p-3"> */}
                      <div
                        className="d-flex gap-3 align-items-center mb-0  pt-2 pb-0"
                        style={styles.stickyHeader}
                      >
                        <div
                          style={{
                            color: "#576f91",
                            fontSize: "13px",
                            fontWeight: 500,
                            width: "100%",

                          }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h4
                              className="mb-0"
                              style={{
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#3c3c3c",
                              }}
                            >
                              {projectData?.project_title}
                            </h4>
                            <p
                              className="mt-0 fs-13"
                              style={{
                                color: "rgb(176, 186, 201)",
                                fontWeight: 300,
                              }}
                            >
                              {projectData?.description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{ marginLeft: "-1rem", marginRight: "-1rem" }}
                      />
                      <div
                        className="pt-0 ps-0 pb-0 mt-2"
                        style={{
                          background: "transparent",
                        }}
                      >
                        <Row className="w-100 ms-0 mb-0 ">
                          <Col
                            md={4}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faUser}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Project Owner
                              </p>
                              <p className="mb-0 " style={styles.values}>
                                {projectData.owner_name}
                              </p>
                            </div>
                          </Col>
                          <Col
                            md={4}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faPhone}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Contact No.
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {/* + {phoneCountryCode} {` ${firstPhone}`} */}
                                {firstPhone ? `+${phoneCountryCode} ${maskContactNumber(firstPhone)}` : "-"}
                              </p>
                            </div>
                          </Col>
                          <Col
                            md={4}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className=" fs-16"
                              style={styles.iconsStyles}
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Email
                              </p>
                              <div className="mb-0 " style={styles.values}>
                                <span
                                  title={projectData?.email}
                                  style={{
                                    color: "#0099ff",
                                    cursor: "pointer",
                                    marginLeft: "0px",
                                  }}
                                >
                                  {projectData?.email?.length > 20
                                    ? `${projectData.email.slice(0, 20)}...`
                                    : projectData?.email}
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col
                            md={4}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faCalendar}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Start Date
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {formatDate(projectData?.start_date)}
                              </p>
                            </div>
                          </Col>
                          <Col
                            md={4}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faCalendar}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                End Date
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {formatDate(projectData?.end_date)}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {/* </Card.Body> */}
                    </Card>

                    <Row className="w-100 ms-0 ps-0 pe-2 mb-2 mt-3 ">
                      <Col md={6} className=" ps-0 pe-0">
                        <Card
                          style={{
                            background: "#fff",
                            paddingTop: "6px",
                            borderRadius: "5px",
                          }}
                        >
                          <Card.Header
                            className="pb-1"
                            style={{
                              marginLeft: "-1.2rem",
                              marginRight: "-1.2rem",
                            }}
                          >
                            <div
                              className="pb-2"
                              style={{ fontWeight: "300", fontSize: "1rem" }}
                            >
                              Associated Contact
                            </div>
                          </Card.Header>
                          {/* <Card.Body className="pt-3"> */}
                          <div
                            className="d-flex gap-2 align-items-center justify-content-between pt-3  "
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <div
                              className=" p-0"
                              style={{ width: 40, borderRadius: "50%" }}
                            >
                              <img
                                src={imgs || "/placeholder.svg"}
                                alt=""
                                style={{ width: "100%", borderRadius: "50%" }}
                              />
                            </div>
                            <div style={{ width: "-webkit-fill-available" }}>
                              <div className="d-flex justify-content-between align-item-center ">


                                <div className="d-flex flex-column">
                                  <p
                                    className="d-flex align-tems-center justify-content-between text-dark"
                                    style={{ fontWeight: 600, textWrap: "nowrap", }}
                                  >

                                    Rahul Jadhav{" "}

                                  </p>
                                  <p style={{ fontWeight: 300 }} className="fs-11">
                                    Designation
                                  </p>



                                </div>
                                <div>
                                  <Badge
                                    bg="warning"
                                    className="myBadgeP"
                                    style={{
                                      fontWeight: 300,
                                      borderRadius: "20px",
                                      marginTop: "10px"
                                    }}
                                  >


                                    Implementation
                                  </Badge>{" "}
                                  <style>
                                    {`
                                      .myBadgeP {
                                        fontWeight: 300 !important;
                                        border-radius: 20px;
                                        color: #000;
                                        marginTop:10px !important;
                                      }
                                    `}
                                  </style>
                                </div>{" "}
                                <div>
                                  <span
                                    className="fs-12"
                                    style={{
                                      color: "#a7a7a7",
                                      fontWeight: 300,
                                    }}
                                  >
                                    Task :{" "}
                                  </span>
                                  <span className="fs-13">5/5</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div
                            className="d-flex gap-2 align-items-center justify-content-between pt-3  "
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <div
                              className=" p-0"
                              style={{ width: 40, borderRadius: "50%" }}
                            >
                              <img
                                src={imgs || "/placeholder.svg"}
                                alt=""
                                style={{ width: "100%", borderRadius: "50%" }}
                              />
                            </div>
                            <div style={{ width: "-webkit-fill-available" }}>
                              <div className="d-flex justify-content-between align-item-center ">


                                <div className="d-flex flex-column">
                                  <p
                                    className="d-flex align-tems-center justify-content-between text-dark"
                                    style={{ fontWeight: 600, textWrap: "nowrap", }}
                                  >

                                    Rahul Jadhav{" "}

                                  </p>
                                  <p style={{ fontWeight: 300 }} className="fs-11">
                                    Designation
                                  </p>



                                </div>
                                <div>
                                  <Badge
                                    bg="warning"
                                    className="myBadgeP"
                                    style={{
                                      fontWeight: 300,
                                      borderRadius: "20px",
                                      marginTop: "10px"
                                    }}
                                  >
                                    Implementation
                                  </Badge>{" "}
                                </div>{" "}
                                <div>
                                  <span
                                    className="fs-12"
                                    style={{
                                      color: "#a7a7a7",
                                      fontWeight: 300,
                                    }}
                                  >
                                    Task :{" "}
                                  </span>
                                  <span className="fs-13">5/5</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr /><div
                            className="d-flex gap-2 align-items-center justify-content-between pt-3  "
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <div
                              className=" p-0"
                              style={{ width: 40, borderRadius: "50%" }}
                            >
                              <img
                                src={imgs || "/placeholder.svg"}
                                alt=""
                                style={{ width: "100%", borderRadius: "50%" }}
                              />
                            </div>
                            <div style={{ width: "-webkit-fill-available" }}>
                              <div className="d-flex justify-content-between align-item-center ">


                                <div className="d-flex flex-column">
                                  <p
                                    className="d-flex align-tems-center justify-content-between text-dark"
                                    style={{ fontWeight: 600, textWrap: "nowrap", }}
                                  >

                                    Rahul Jadhav{" "}

                                  </p>
                                  <p style={{ fontWeight: 300 }} className="fs-11">
                                    Designation
                                  </p>



                                </div>
                                <div>
                                  <Badge
                                    bg="warning"
                                    className="myBadgeP"
                                    style={{
                                      fontWeight: 300,
                                      borderRadius: "20px",
                                      marginTop: "10px"
                                    }}
                                  >
                                    Implementation
                                  </Badge>{" "}
                                </div>{" "}
                                <div>
                                  <span
                                    className="fs-12"
                                    style={{
                                      color: "#a7a7a7",
                                      fontWeight: 300,
                                    }}
                                  >
                                    Task :{" "}
                                  </span>
                                  <span className="fs-13">5/5</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr /><div
                            className="d-flex gap-2 align-items-center justify-content-between pt-3  "
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <div
                              className=" p-0"
                              style={{ width: 40, borderRadius: "50%" }}
                            >
                              <img
                                src={imgs || "/placeholder.svg"}
                                alt=""
                                style={{ width: "100%", borderRadius: "50%" }}
                              />
                            </div>
                            <div style={{ width: "-webkit-fill-available" }}>
                              <div className="d-flex justify-content-between align-item-center ">


                                <div className="d-flex flex-column">
                                  <p
                                    className="d-flex align-tems-center justify-content-between text-dark"
                                    style={{ fontWeight: 600, textWrap: "nowrap", }}
                                  >

                                    Rahul Jadhav{" "}

                                  </p>
                                  <p style={{ fontWeight: 300 }} className="fs-11">
                                    Designation
                                  </p>



                                </div>
                                <div>
                                  <Badge
                                    bg="warning"
                                    className="myBadgeP"
                                    style={{
                                      fontWeight: 300,
                                      borderRadius: "20px",
                                      marginTop: "10px"
                                    }}
                                  >
                                    Implementation
                                  </Badge>{" "}
                                </div>{" "}
                                <div>
                                  <span
                                    className="fs-12"
                                    style={{
                                      color: "#a7a7a7",
                                      fontWeight: 300,
                                    }}
                                  >
                                    Task :{" "}
                                  </span>
                                  <span className="fs-13">5/5</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />

                          {/* </Card.Body> */}
                        </Card>
                      </Col>

                      <Col md={6} className="pe-0">
                        <Card
                          style={{
                            background: "#fff",
                            paddingTop: "6px",
                            borderRadius: "5px",
                            height: "97%",
                          }}
                        >
                          <Card.Header
                            className="pb-1"
                            style={{
                              marginLeft: "-1.2rem",
                              marginRight: "-1.2rem",
                            }}
                          >
                            <div
                              className="pb-2"
                              style={{ fontWeight: "300", fontSize: "1rem" }}
                            >
                              Project Progress
                            </div>
                          </Card.Header>
                          <Card.Body
                            className=""
                            style={{ height: "250px", width: "100%" }}
                          >
                            {(() => {
                              const stages = stageData?.[0]?.stages || [];

                              const stageNames = stages.map(
                                (stage) => stage.stage_name || "Unknown Stage"
                              );
                              const values = stages.map((stage) =>
                                stage.progress
                                  ? Number(stage?.progress?.toFixed(0))
                                  : 0
                              );

                              const colors = [
                                "#3b82f6", // Blue
                                "#10b981", // Green
                                "#f59e0b", // Amber
                                "#ef4444", // Red
                                "#8b5cf6", // Purple
                                "#06b6d4", // Cyan
                                "#84cc16", // Lime
                              ];

                              const backgroundColors = values.map(
                                (value, index) =>
                                  value === 0
                                    ? "transparent"
                                    : colors[index % colors.length]
                              );

                              const borderColors = values.map((value, index) =>
                                value === 0
                                  ? "#9ca3af"
                                  : colors[index % colors.length]
                              );

                              const data = {
                                labels: stageNames,
                                datasets: [
                                  {
                                    data: values,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    borderWidth: 2,
                                    borderRadius: 3,
                                    barPercentage: 0.8,
                                    categoryPercentage: 0.9,
                                    minBarLength: 0,
                                  },
                                ],
                              };

                              const options = {
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  legend: { display: false },
                                  tooltip: {
                                    enabled: true,
                                    backgroundColor: "#ffffff",
                                    titleColor: "#000000",
                                    bodyColor: "#000000",
                                    borderColor: "#e5e7eb",
                                    borderWidth: 1,
                                    titleFont: { size: 12, weight: "bold" },
                                    bodyFont: { size: 12 },
                                    callbacks: {
                                      label: (context) =>
                                        `${stageNames[context.dataIndex]}: ${context.raw
                                        }%`,
                                    },
                                  },
                                  datalabels: {
                                    display: false,
                                  },
                                },
                                scales: {
                                  x: {
                                    ticks: {
                                      display: true,
                                      color: "#4b5563",
                                      font: { size: 11, weight: "500" },
                                      autoSkip: false,
                                      maxRotation: 45,
                                      minRotation: 0,
                                      callback: function (value, index) {
                                        const label =
                                          this.getLabelForValue(value);
                                        return label.length > 30
                                          ? label.slice(0, 30) + "…"
                                          : label;
                                      },
                                    },
                                    grid: {
                                      display: false,
                                      drawBorder: false,
                                    },
                                  },
                                  y: {
                                    beginAtZero: true,
                                    max: 100,
                                    ticks: {
                                      stepSize: 25,
                                      callback: (val) => `${val?.toFixed(0)}%`,
                                      color: "#6b7280",
                                      font: { size: 11, weight: "500" },
                                    },
                                    grid: {
                                      color: "#f3f4f6",
                                      drawBorder: false,
                                    },
                                  },
                                },
                              };

                              return <Bar data={data} options={options} />;
                            })()}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    md={5}
                    style={{
                      borderLeft: "1px solid #d1d4e3",
                      position: "sticky",
                      top: "0",
                      overflowY: "auto",
                      height: "calc(100vh - 6rem)",
                      paddingLeft: ".5rem",
                    }}
                    className="pt-0"
                  >
                    <Tab.Container defaultActiveKey="tasks">
                      <Card className="bg-white h-100 cardBorders mb-0 rounded-2 px-2 pe-0">
                        <Card.Header className="px-0 d-flex justify-content-between align-items-center py-0 cardHeaderBorders">
                          <div style={styles.ulStyles}>
                            <div className="d-flex align-items-center gap-1 navForTasks">
                              <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap gap-2"
                              >
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="tasks"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <CheckSquare size={13} className="me-1" />{" "}
                                    <span className={styles.headerText}>
                                      Task
                                    </span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="notes"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                    onClick={() => {
                                      fetchNotes();
                                    }}
                                  >
                                    <StickyNote size={13} className="me-1" />{" "}
                                    <span>Notes</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="meetings"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <Calendar size={13} className="me-1" />{" "}
                                    <span>Meetings</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                  className="me-0"
                                  onClick={() => {
                                    setDocumentShow(true);
                                  }}
                                >
                                  <Nav.Link
                                    eventKey="documents"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <FileCheck size={13} className="me-1" />{" "}
                                    <span>Documents</span>
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </div>
                          </div>
                        </Card.Header>
                        <Card.Body
                          className="px-0 pt-0"
                          style={{ height: "90%" }}
                        >
                          <Tab.Content className="h-100">
                            {/* task list */}
                            <Tab.Pane
                              eventKey="tasks"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                              className="p-0 pt-2 h-100"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-0  mt-2 px-2">
                                <div
                                  className=" mb-0"
                                  style={{ fontSize: "19px", lineHeight: 1.3 }}
                                >
                                  Tasks
                                  <p className="subHeadingText">
                                    Upcoming tasks required your action.
                                  </p>
                                </div>
                                <Button
                                  className="btn btn-default-outline"
                                  style={styles.listButtonsStyles}
                                  onClick={() => {
                                    if (!taskGrant?.isCreate) {
                                      toast.warning("You are not authorized for this action!")
                                      return
                                    }
                                    handleAddTask();
                                  }}
                                >
                                  <FontAwesomeIcon icon={faPlus} /> Add
                                </Button>
                              </div>
                              <hr style={{ marginBottom: "0px" }} />
                              <div className={`${Sau.scrollerDiv}`}>
                                <div className="mt-3">
                                  <div className="p-2 bg-white ps-0 pe-0">
                                    <div className="timeline">
                                      {
                                        taskGrant?.isView ?
                                          projectData?.stages?.map((ev, idx) => {
                                            const stageTasks =
                                              projectData?.stages?.find(
                                                (stage) => stage.id === ev.id
                                              )?.tasks || [];

                                            const isExpanded =
                                              expandedStages[ev.id];
                                            const tasksToShow = isExpanded
                                              ? stageTasks
                                              : stageTasks.slice(0, 2);
                                            const hasMoreTasks =
                                              stageTasks.length > 2;

                                            return (
                                              <div
                                                className="d-flex mb-4"
                                                key={idx}
                                              >
                                                {/* LEFT COLUMN — FIXED CENTER LINE FOR BOTH STAGE + TASKS */}
                                                <div
                                                  style={{
                                                    width: "22px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    position: "relative",
                                                  }}
                                                >
                                                  {/* STAGE DOT */}
                                                  <div
                                                    style={{
                                                      width: "14px",
                                                      height: "14px",
                                                      borderRadius: "50%",
                                                      backgroundColor:
                                                        ev.iconType === "orange"
                                                          ? "#f1a545"
                                                          : ev.iconType === "gray"
                                                            ? "#999"
                                                            : "#28a745",
                                                      zIndex: 10,
                                                      marginBottom: "5px",
                                                    }}
                                                  ></div>

                                                  {/* CENTER VERTICAL DOTTED LINE */}
                                                  <div
                                                    style={{
                                                      flexGrow: 1,
                                                      width: "2px",
                                                      backgroundImage:
                                                        "linear-gradient(#ccc 40%, rgba(255,255,255,0) 0%)",
                                                      backgroundRepeat: "repeat-y",
                                                      backgroundSize: "2px 10px",
                                                    }}
                                                  ></div>
                                                </div>

                                                {/* RIGHT CONTENT */}
                                                <div className="flex-grow-1 ps-2">
                                                  {/* Stage Name + Add Button */}
                                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <span
                                                      className="d-flex flex-column"
                                                      style={{
                                                        lineHeight: "normal",
                                                      }}
                                                    >
                                                      <span
                                                        className="fw-bold"
                                                        style={{ fontSize: "15px" }}
                                                      >
                                                        {ev.stage_name}

                                                      </span>
                                                      <span
                                                        style={{ fontSize: "11px", fontWeight: 300 }}
                                                      >
                                                        This stage is {Number(ev?.taskCompletion_percentage).toFixed(0)}% completed.
                                                      </span>
                                                    </span>

                                                    <span
                                                      className="text-primary fs-13"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => {
                                                        if (!taskGrant?.isCreate) {
                                                          toast.warning("You are not authorized for this action!")
                                                          return
                                                        }
                                                        handleIndividualtask(ev)
                                                      }
                                                      }
                                                    >
                                                      + Task
                                                    </span>
                                                  </div>

                                                  {/* TASK LIST */}
                                                  <div className="mt-2">
                                                    {/* Empty Message */}
                                                    {tasksToShow.length === 0 && (
                                                      <div
                                                        className="d-flex align-items-center"
                                                        style={{
                                                          border: "1px solid #eee",
                                                          borderRadius: "12px",
                                                          padding: "10px 12px",
                                                          background: "#fff",
                                                          boxShadow:
                                                            "0 1px 4px rgba(0,0,0,0.08)",
                                                          height: "60px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            height: 35,
                                                            width: 35,
                                                            borderRadius: "10px",
                                                            background: "#f4f6ff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent:
                                                              "center",
                                                            marginRight: "10px",
                                                          }}
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faListCheck}
                                                            className="text-primary fs-15"
                                                          />
                                                        </div>

                                                        <span
                                                          style={{
                                                            color: "#999",
                                                            fontSize: "13px",
                                                          }}
                                                        >
                                                          No tasks available
                                                        </span>
                                                      </div>
                                                    )}

                                                    {/* ALL TASKS */}
                                                    {tasksToShow.map(
                                                      (task, taskIndex) => {
                                                        const today = new Date()
                                                          .toISOString()
                                                          .split("T")[0];

                                                        const truncatedName =
                                                          task.task_name?.length >
                                                            30
                                                            ? task.task_name.slice(
                                                              0,
                                                              30
                                                            ) + "..."
                                                            : task.task_name;

                                                        const description =
                                                          task.description?.length >
                                                            30
                                                            ? task.description.slice(
                                                              0,
                                                              30
                                                            ) + "..."
                                                            : task.description;

                                                        return (
                                                          <div
                                                            key={taskIndex}
                                                            className="position-relative"
                                                          >
                                                            {/* TASK DOT — EXACTLY ALIGNED WITH THE CENTER LINE */}
                                                            <div
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                left: "-1.45rem", // PERFECT alignment
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                width: "10px",
                                                                height: "10px",
                                                                borderRadius: "50%",
                                                                backgroundColor:
                                                                  "rgb(133 66 104)",
                                                                zIndex: 20,
                                                              }}
                                                            ></div>

                                                            {/* TASK CARD */}
                                                            <div
                                                              className="d-flex align-items-center"
                                                              style={{
                                                                border:
                                                                  "1px solid rgb(229 226 226)",
                                                                borderRadius: 4,
                                                                padding:
                                                                  "10px 12px",
                                                                background:
                                                                  getRestrictedLightColor(),
                                                                boxShadow:
                                                                  "rgb(0 0 0 / 19%) 0px 0px 10px",
                                                                marginBottom:
                                                                  "10px",
                                                                height: "60px",
                                                              }}
                                                            >
                                                              {/* ICON */}
                                                              <div
                                                                style={{
                                                                  height: 35,
                                                                  width: 35,
                                                                  borderRadius:
                                                                    "10px",
                                                                  background:
                                                                    "#f4f6ff",
                                                                  display: "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  marginRight:
                                                                    "10px",
                                                                }}
                                                              >
                                                                {/* <FontAwesomeIcon
                                                              icon={faListCheck}
                                                              className="text-primary fs-15"
                                                            /> */}

                                                                <img
                                                                  src={projectIcon}
                                                                  alt=""
                                                                  className="text-primary fs-15"
                                                                  style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                  }}
                                                                />
                                                              </div>

                                                              {/* TEXT */}
                                                              <div className="flex-grow-1">
                                                                <span
                                                                  className="fw-semibold d-block"
                                                                  style={{
                                                                    marginBottom:
                                                                      "-6px",
                                                                    fontSize:
                                                                      "13px",
                                                                    color: "#222",
                                                                    whiteSpace:
                                                                      "nowrap",
                                                                    overflow:
                                                                      "hidden",
                                                                    textOverflow:
                                                                      "ellipsis",
                                                                  }}
                                                                  title={
                                                                    task?.task_name
                                                                  }
                                                                >
                                                                  {truncatedName}
                                                                </span>

                                                                <span
                                                                  style={{
                                                                    fontSize:
                                                                      "11px",
                                                                    color: "#777",
                                                                  }}
                                                                  title={
                                                                    task?.description
                                                                  }
                                                                >
                                                                  {description}
                                                                </span>
                                                              </div>

                                                              {/* DATE */}
                                                              <span
                                                                className={`ms-3 me-3 fs-12 ${task.due_date >
                                                                  today
                                                                  ? "text-success"
                                                                  : "text-danger"
                                                                  }`}
                                                                style={{
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                <FontAwesomeIcon
                                                                  icon={
                                                                    faCalendarDays
                                                                  }
                                                                  className="fs-11 me-1"
                                                                />
                                                                {formatDate(
                                                                  task.due_date
                                                                )}
                                                              </span>

                                                              {/* STATUS */}
                                                              <i
                                                                title={
                                                                  task.task_status
                                                                }
                                                                onClick={() =>
                                                                  task.task_status !==
                                                                  "close" &&
                                                                  handleCheckBoxClick(
                                                                    task
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    task.task_status ===
                                                                      "close"
                                                                      ? "default"
                                                                      : "pointer",
                                                                  marginRight:
                                                                    "14px",
                                                                  color:
                                                                    task.task_status ===
                                                                      "complete"
                                                                      ? "#18cd1a"
                                                                      : task.task_status ===
                                                                        "progress"
                                                                        ? "#f1c232"
                                                                        : "#ccc",
                                                                }}
                                                                className={
                                                                  task.task_status ===
                                                                    "complete"
                                                                    ? "fa-solid fa-circle-check fs-16"
                                                                    : task.task_status ===
                                                                      "progress"
                                                                      ? "fa-solid fa-circle-half-stroke fs-16"
                                                                      : "fa-regular fa-circle fs-16"
                                                                }
                                                              />

                                                              {/* USER ICON */}
                                                              <div
                                                                className="me-3"
                                                                Title={
                                                                  task?.owner_name
                                                                }
                                                              >
                                                                <img
                                                                  src={
                                                                    task.owner_image
                                                                      ? ""
                                                                      : defaultImage
                                                                  }
                                                                  alt="user"
                                                                  style={{
                                                                    height: 30,
                                                                    width: 30,
                                                                    borderRadius:
                                                                      "50%",
                                                                    objectFit:
                                                                      "cover",
                                                                  }}
                                                                />
                                                              </div>

                                                              {/* MENU */}
                                                              <Dropdown>
                                                                <Dropdown.Toggle
                                                                  variant="outline"
                                                                  className="p-0 border-0 no-arrow"
                                                                  style={{
                                                                    background:
                                                                      "transparent",
                                                                  }}
                                                                >
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faEllipsisVertical
                                                                    }
                                                                    className="text-muted fs-14"
                                                                  />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!taskGrant?.isEdit) {
                                                                        toast.warning("You are not authorized for this action")
                                                                        return
                                                                      }
                                                                      handleInCompleteTask(task)
                                                                    }
                                                                    }
                                                                  >
                                                                    <FontAwesomeIcon
                                                                      icon={faEdit}
                                                                      className="pe-1"
                                                                    />{" "}
                                                                    InComplete
                                                                  </Dropdown.Item>
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!taskGrant?.isEdit) {
                                                                        toast.warning("You are not authorized for this action")
                                                                        return
                                                                      }
                                                                      handleCompleteTask(task)
                                                                    }
                                                                    }
                                                                  >
                                                                    <FontAwesomeIcon
                                                                      icon={faClone}
                                                                      className="pe-1"
                                                                    />{" "}
                                                                    Complete
                                                                  </Dropdown.Item>
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!taskGrant?.isEdit) {
                                                                        toast.warning("You are not authorized for this action")
                                                                        return
                                                                      }
                                                                      handleCancleTask(task)
                                                                    }
                                                                    }
                                                                  >
                                                                    <FontAwesomeIcon
                                                                      icon={
                                                                        faMailForward
                                                                      }
                                                                      className="pe-1"
                                                                    />{" "}
                                                                    Cancel
                                                                  </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    )}

                                                    {/* SHOW MORE */}
                                                    {hasMoreTasks && (
                                                      <button
                                                        className="btn btn-link p-0 fs-12"
                                                        style={{
                                                          textDecoration: "none",
                                                        }}
                                                        onClick={() =>
                                                          toggleStageExpansion(
                                                            ev.id
                                                          )
                                                        }
                                                      >
                                                        {isExpanded
                                                          ? "Show Less"
                                                          : `Show More (${stageTasks.length - 2
                                                          } more)`}
                                                      </button>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })
                                          :
                                          <>You are not authorized to view Project Task!</>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tab.Pane>

                            {/* notes pane */}
                            <Tab.Pane
                              eventKey="notes"
                              className="p-0 pt-2"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                                height: "calc(100vh - 13rem)",
                                overflow: "auto",
                                borderRadius: 0,
                              }}
                            >
                              <div
                                style={{
                                  minHeight: "200px",
                                  height: "23rem",
                                  overflow: "auto",
                                }}
                              >
                                {isNotesLoading && !notesContent ? (
                                  <div className="text-center py-4">
                                    Loading notes...
                                  </div>
                                ) : (
                                  <>
                                    {/* Editor when add/update note */}
                                    {(!isNotesOpen || editingNoteId) && (
                                      <>
                                        <div className="d-flex justify-content-between align-items-center mb-0 px-3">
                                          <div
                                            className=" mb-0"
                                            style={{ fontSize: "19px" }}
                                          >
                                            Notes
                                          </div>
                                        </div>
                                        <hr />
                                        <div
                                          className="mb-3 p-2"
                                          style={{
                                            animation:
                                              "cardEntry 1s ease-out forwards",
                                          }}
                                        >
                                          <ReactQuill
                                            theme="snow"
                                            value={notesContent}
                                            onChange={(value) =>
                                              setNotesContent(value)
                                            }
                                            placeholder="Write your message..."
                                            style={{ minHeight: "160px" }}
                                            modules={{
                                              toolbar: [
                                                [{ header: [1, 2, false] }],
                                                [
                                                  "bold",
                                                  "italic",
                                                  "underline",
                                                  "link",
                                                ],
                                                [
                                                  { list: "ordered" },
                                                  { list: "bullet" },
                                                ],
                                                ["blockquote", "code-block"],
                                                ["clean"],
                                              ],
                                            }}
                                          />
                                        </div>

                                        {notesError && (
                                          <p className="text-danger mt-0 mb-0 fs-12">
                                            {notesError}
                                          </p>
                                        )}

                                        <div className="d-flex justify-content-end gap-2 mb-2 pe-2">
                                          <Button
                                            variant="outline-default"
                                            style={{ fontSize: 13 }}
                                            onClick={() => {
                                              setNotesContent("");
                                              setEditingNoteId(null);
                                              setIsNotesOpen(true);
                                            }}
                                            disabled={isNotesLoading}
                                          >
                                            Cancel
                                          </Button>
                                          <Button
                                            variant="default"
                                            style={{ fontSize: 13 }}
                                            onClick={() => {
                                              handleSaveNote();
                                              setIsNotesOpen(true);
                                            }}
                                            disabled={isNotesLoading}
                                          >
                                            {isNotesLoading
                                              ? "Saving..."
                                              : editingNoteId
                                                ? "Update"
                                                : "Save"}
                                          </Button>
                                        </div>
                                      </>
                                    )}

                                    {/* Notes List */}
                                    <div className="notes-list p-1 px-1">
                                      <div className="d-flex justify-content-between align-items-center mb-0 mt-2 px-2">
                                        <div
                                          className="mt-2 mb-0"
                                          style={{
                                            fontSize: "19px",
                                            lineHeight: 1.3,
                                          }}
                                        >
                                          Notes
                                          {/* <p className="subHeadingText">
                                                                        previous notes
                                                                      </p> */}
                                        </div>
                                        {isNotesOpen && (
                                          <Button
                                            className="btn btn-default-outline"
                                            // style={styles.buttons}
                                            style={styles.listButtonsStyles}
                                            onClick={() => {
                                              if (!noteGrant?.isCreate) {
                                                toast.warning(
                                                  "You are not authorized for this action!",
                                                )
                                                return
                                              }
                                              setIsNotesOpen(false) // show editor when Add is clicked
                                              setNotesContent("")
                                              setEditingNoteId(null)
                                            }}
                                            disabled={isNotesLoading}
                                          >
                                            {isNotesLoading ? (
                                              <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            ) : (
                                              <>
                                                <FontAwesomeIcon
                                                  icon={faPlus}
                                                />{" "}
                                                Add
                                              </>
                                            )}
                                          </Button>
                                        )}
                                      </div>
                                      <hr style={{ marginBottom: "0px" }} />

                                      {
                                        noteGrant?.isView ?
                                          notes.length > 0 ? (
                                            notes.map((note) => {
                                              const text =
                                                note.notes +
                                                '<span style="display:inline"></span>';

                                              const cleanHTML = text;

                                              const wordLimit = 20;
                                              const words = cleanHTML.split(" ");
                                              const isExpanded =
                                                expandedNoteId === note.id;
                                              const shouldShowButton =
                                                words.length > wordLimit;

                                              const displayedText = isExpanded
                                                ? cleanHTML
                                                : words
                                                  .slice(0, wordLimit)
                                                  .join(" ");

                                              const inlineHtml =
                                                forceInline(displayedText);

                                              return (
                                                <div
                                                  key={note.id}
                                                  className="p-3 border-bottom"
                                                >
                                                  <div className="d-flex justify-content-between align-items-start">
                                                    {/* Note Text */}
                                                    <div
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "black",
                                                      }}
                                                      className="d-flex"
                                                    >
                                                      <FaStickyNote
                                                        size={18}
                                                        style={{
                                                          minWidth: 18,
                                                          marginRight: 10,
                                                          marginTop: 4,
                                                        }}
                                                      />
                                                      <div
                                                        style={{
                                                          fontSize: "14px",
                                                          color: "black",
                                                        }}
                                                      >
                                                        <ExpandableNote
                                                          key={note.id}
                                                          note={note}
                                                        />
                                                      </div>
                                                    </div>
                                                    {/* Dropdown */}
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="none"
                                                        id={`dropdown-note-${note.id}`}
                                                        style={{
                                                          border: "none",
                                                          background: "none",
                                                          padding: 0,
                                                        }}
                                                        className="dropdownTogglesBtns ms-3"
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEllipsisVertical}
                                                          style={{ color: "black" }}
                                                        />
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu>
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!noteGrant?.isEdit) {
                                                              toast.warning("You are not authorized for this action!")
                                                              return
                                                            }
                                                            handleEditNote(note.id)
                                                          }}
                                                        >
                                                          Edit
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!noteGrant?.isDelete) {
                                                              toast.warning("You are not authorized for this action!")
                                                              return
                                                            }
                                                            setNoteToDelete(note);
                                                            setShowDeleteModal(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          Delete
                                                        </Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </div>

                                                  {/* Footer with user + date */}
                                                  <p
                                                    className="mb-0 mt-3 d-flex justify-content-between"
                                                    style={{
                                                      fontWeight: 300,
                                                      fontSize: 12,
                                                      color: "#aeaeae",
                                                    }}
                                                  >
                                                    {note.added_name}
                                                    <span>
                                                      {formatDateInAlphabeticalMonth(
                                                        note.created_at
                                                      )}{" "}
                                                      | at{" "}
                                                      {formatTime(note.created_at)}
                                                    </span>
                                                  </p>
                                                </div>
                                              );
                                            })
                                          ) : (
                                            <div
                                              class="d-flex justify-content-center align-items-center"
                                              style={{ position: "absolute", left: " 24%" }}
                                            >
                                              <img
                                                src={nodata}
                                                alt=""
                                                style={{ width: "17rem", marginTop: "0" }}
                                              />
                                            </div>
                                          )
                                          :
                                          <>You are not authorized to view Notes listing!</>
                                      }
                                    </div>
                                  </>
                                )}
                              </div>
                            </Tab.Pane>

                            {/* meetings */}
                            <Tab.Pane
                              eventKey="meetings"
                              className="p-0 pt-2 px-3"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <div className="mt-3">
                                <Meetings
                                  leadId={projectData?.id}
                                  email={projectData?.email}
                                  fullName={projectData?.contact_name}
                                  module_name="contact"
                                  meetingGrant={meetingGrant}
                                />
                              </div>
                            </Tab.Pane>

                            {/* document listing */}
                            <Tab.Pane
                              className="p-0 pt-3"
                              eventKey="documents"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              {documentShow && (
                                <DocumentsList
                                  onDelete={onDelete}
                                  documentData={documentData}
                                  // setDocumentData={setDocumentData}
                                  setDeleteDocument={setDeleteDocument}
                                  documents={documents}
                                  fetchDocument={fetchDocument}
                                  setDocuments={setDocuments}
                                  setDocumentToDelete={setDocumentToDelete}
                                  documentToDelete={documentToDelete}
                                  id={projectData?.id}
                                  moduleType="project"
                                  show={show}
                                  docGrant={docGrant}
                                />
                              )}
                            </Tab.Pane>
                          </Tab.Content>
                        </Card.Body>
                      </Card>
                    </Tab.Container>
                  </Col>
                </Row>
              </Offcanvas.Body>
            </>
          )}
        </Offcanvas>
      </>

      <TasksOffcanvas
        taskShow={taskShow}
        onClose={() => setTaskShow(false)}
        setAddIndivisualTask={setAddIndivisualTask}
        addIndivisbleTask={addIndivisbleTask}
        setEditTaskData={setEditTaskData}
        editTastData={editTastData}
        setProjectId={setProjectId}
        projectId={projectId}
        fetchStages={fetchStages}
        setFetchTaskToken={setFetchTaskToken}
        fetchDetailsProjects={fetchDetailsProjects}
        refetch={refetch}
        moduleName={moduleName}
      />

      <Modal show={showConfirm} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {completeTaskClicked
              ? "Complete Task"
              : cancleTaskClicked
                ? "Cancel Task"
                : inCompleteTaskClicked
                  ? "Close Task"
                  : "Task Status"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {completeTaskClicked ? (
            <p>Are you sure you want to mark as complete this task?</p>
          ) : (
            <p>Are you sure you want to cancel this task?</p>
          )}
          {completeTaskClicked ? (
            ""
          ) : (
            <Form.Group controlId="rejectReason">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Please provide a reason for cancellation"
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default-outline" onClick={handleCloseModal}>
            Cancel
          </button>
          <button
            className="btn btn-default"
            onClick={handleConfirm}
            disabled={
              completeTaskClicked
                ? false
                : rejectReason.trim() === "" || loading
            }
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const styles = {
  listButtonsStyles: {
    fontSize: "13px",
    height: "30px",
    width: "auto",
    gap: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    color: "#fff",
  },
  listButtonsStyless: {
    fontSize: "13px",
    height: "30px",
    width: "30px",
    gap: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    color: "#fff",
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 13,
    color: "#fff",
  },
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#007bff",
    border: "1px solid #007bff",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "34px",
    width: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f9fa",
    border: "1px solid #dee2e6",
  },
  ulStyles: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    justifyContent: "space-between",
    width: "100%",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  navLinksStyleLast: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "none",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  navLinksStyleLastLast: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "none",
    fontSize: 14,
    height: "99%",
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "11px",
    background: "#fff",
    top: "0px",
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "9px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "15px",
    height: "15px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
    letterSpacing: "0.25px"
  },

  navLinks: {
    color: "#848484",
    fontWeight: 500,
    fontSize: 13,
    display: "flex",
    alignItems: "center",
  },
  taskTitles: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
};
